import { render, staticRenderFns } from "./terms-of-use.vue?vue&type=template&id=5d3f9bca"
import script from "./terms-of-use.vue?vue&type=script&lang=js"
export * from "./terms-of-use.vue?vue&type=script&lang=js"
import style0 from "./terms-of-use.vue?vue&type=style&index=0&id=5d3f9bca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports